<div mat-dialog-content class="all">
  <lemon-dialog-header>{{ 'asiakaskysely.otsikko' | translate | async }}</lemon-dialog-header>

  <div class="text-part">
    <p>{{ 'asiakaskysely.leipateksti-1' | translate | async }}</p>
    <p>{{ 'asiakaskysely.leipateksti-2' | translate | async }}</p>
    @if (voimassaAstiFormatted) {
      <p>{{ 'asiakaskysely.voimassa-asti' | translate: { paiva: voimassaAstiFormatted } | async }}</p>
    }
  </div>

  <div class="button-container">
    <button mat-button class="secondarybutton" [attr.aria-label]="'asiakaskysely.myohemmin' | translate | async" (click)="myohemmin($event)">{{ 'asiakaskysely.myohemmin' | translate | async }}</button>
    <button mat-button class="primarybutton" [attr.aria-label]="'asiakaskysely.vastaa' | translate | async" (click)="vastaa($event)">{{ 'asiakaskysely.vastaa' | translate | async }}</button>
  </div>
</div>
